import { List, ListProps, Paper } from '@mui/material';
import { MenuProvider } from './context';

interface MenuProps extends ListProps {
  onClose?: () => void;
  minWidth?: string | number;
}

const Menu = ({
  onClose,
  minWidth = '250px',
  children,
  ...listProps
}: MenuProps) => {
  return (
    <Paper elevation={8}>
      <MenuProvider onClose={onClose}>
        <List {...listProps} sx={{ minWidth }}>
          {children}
        </List>
      </MenuProvider>
    </Paper>
  );
};

export default Menu;
